import { createElement } from "react";
import { Trans } from "react-i18next";
import { put } from "../../../common/api/apiShared";
import { Result } from "../../../common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { SecurityMeasureSaveModel, SecurityMeasureViewModel } from "../securityMeasures/SecurityMeasures.types";
import { IChangeSecurityMeasureStatusDialogDataMapping } from "./ChangeSecurityMeasureStatusDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useChangeSecurityMeasureStatusDialogDataMapping(props: IChangeSecurityMeasureStatusDialogDataMapping) {
    const snackbar = useDotLegalSnackbar();

    const changeActiveStatusMutation = useDotLegalMutation(changeStatus);

    const changeActiveStatus = (securityMeasure: SecurityMeasureViewModel) => {
        changeActiveStatusMutation.mutateAsync(securityMeasure, {
            onSuccess: (response: Result<string>) => {
                props.onCloseDialog();

                if (response.success()) {
                    snackbar.show(createElement(Trans, { i18nKey: "activeStatusChanged", values: { name: securityMeasure.name } }));
                    props.refetch();
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "SecurityMeasureStatusNotChanged", values: { name: securityMeasure.name } }), "warning");
                }
            },
        });
    };

    function changeStatus(securityMeasure: SecurityMeasureViewModel) {
        if (securityMeasure.isCustom) return put<string>(`/securitymeasures/${securityMeasure.id}/toggleSecurityMeasureActive`, !securityMeasure.isActive);
        else return put<string>(`/securitymeasures/${securityMeasure.id}/toggleSecurityMeasureMasterDataActive`, !securityMeasure.isActive);
    }

    return {
        changeActiveStatus,
        inProgress: changeActiveStatusMutation.isLoading,
    };
}
